import { UrlHelper, UrlHelperConfiguration } from "./url-helper";
import { BrowserBarcodeReader } from '@zxing/library';

interface GoodsReceiptConfiguration {
    ids: GoodsReceiptPageElementIds;
    urlHelperConfiguration: UrlHelperConfiguration;
}


interface GoodsReceiptPageElementIds {
    locationSelectId: string;
    barcodeScannerId: string;
    purchaseOrderNumberId: string;
    videoElementId: string;
    loadingTextId: string;
    videoDevicesId: string;
}

$(document).on("turbolinks:load", function () {
    const configElement = document.getElementById("goods-receipt-config");
    if (configElement) {
        const config: GoodsReceiptConfiguration = JSON.parse(configElement.innerHTML);
        new GoodsReceiptPage(config.ids, config.urlHelperConfiguration);
    }
});

export class GoodsReceiptPage {
    constructor(ids: GoodsReceiptPageElementIds, urlHelperConfiguration: UrlHelperConfiguration)
    {
        const urlHelper = new UrlHelper(urlHelperConfiguration);
        const $locationSelect = $(`#${ids.locationSelectId}`);
        $locationSelect.on("change", () => urlHelper.navigate(`?locationId=${$locationSelect.val()}`));
        (async () => await this.setupBarcodeScanner(ids))();
    }

    async setupBarcodeScanner(ids: GoodsReceiptPageElementIds)
    {
        const $loadingText = $(`#${ids.loadingTextId}`);
        const $videoElement = $(`#${ids.videoElementId}`) as JQuery<HTMLVideoElement>;
        const $barcodeScanner = $(`#${ids.barcodeScannerId}`);
        const $videoDevicesSelect = $(`#${ids.videoDevicesId}`) as JQuery<HTMLSelectElement>;
        const codeReader = new BrowserBarcodeReader();
        const videoInputDevices = await codeReader.listVideoInputDevices();
        for (const devices of videoInputDevices) {
            const optionElement = document.createElement('option');
            optionElement.text = devices.label;
            optionElement.value = devices.deviceId;
            $videoDevicesSelect.get(0).appendChild(optionElement);
        }

        const resetState = () => {
            codeReader.reset();
            $videoElement.hide();
            $loadingText.hide();
            $videoDevicesSelect.hide();
        }

        $videoDevicesSelect.val(videoInputDevices[0].deviceId);
        const startScanning = async () => {
            $videoElement.get(0).onplaying = () => $loadingText.hide();
            try
            {
                const result = await codeReader.decodeOnceFromVideoDevice($videoDevicesSelect.val() as string, ids.videoElementId);
                $(`#${ids.purchaseOrderNumberId}`).val(result.getText());
                resetState();
            }
            catch (ex)
            {
                console.log("Exception occured trying to load browser barcode reader!", ex);
            }
        }

        $videoDevicesSelect.on('change', (event) => {
            event.preventDefault();
            $loadingText.show();
            startScanning();
        });
        $barcodeScanner.on("click", (event) => {
            event.preventDefault();
            if ($videoElement.is(":hidden"))
            {
                $videoElement.show();
                $loadingText.show();
                if (videoInputDevices.length > 1) {
                    $videoDevicesSelect.show();
                }
            }
            else if ($videoElement.is(":visible"))
            {
                resetState();
                return;
            }

            startScanning();
        });
    }
}